/**
 * @file
 */

export default (Drupal, once) => {

  Drupal.behaviors.basicTables = {
    attach (context) {
      once('basictables', '#block-dukecancernetwork-content table', context).forEach(function () {

        new basictable('#block-dukecancernetwork-content table', {
          breakpoint: 768,
        })

      })
    }
  }
}
